import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Cancellation Policies",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "ordering",
        displayName: "Order",
      },
      {
        fieldName: "active",
        displayName: "Active",
        restrictionMessage:
          "Policy linked to a condition. It is not possible to perform this action",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "motorsList",
        displayName: "Motors",
      },
      {
        fieldName: "uso",
        displayName: "Usage",
      },
      {
        fieldName: "dates",
        displayName: "Dates",
      },
      {
        fieldName: "enableAutomaticCharge",
        displayName: "Automatic charges",
      },
      {
        fieldName: "penaltyDeposit",
        displayName: "Online expense charge",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
      },
      {
        fieldName: "validFrom",
        placeholder: "Enter a date",
        displayName: "Start date",
        tooltip:
          "This date refers to the time at which the stay will take place (travel window). The policy will be activated if the desired check-in and check-out dates are within the range",
      },
      {
        fieldName: "validTo",
        placeholder: "Enter a date",
        displayName: "End date",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
      },
      {
        fieldName: "configurations",
        displayName: "Constraints",
        introductionText: [
          "Create different penalties depending on the anticipation of cancellation",
          "Important! Check that the policies are correctly applied in the engine",
        ],
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
      {
        fieldName: "agrWarningMessage",
        displayName: "",
      },
      {
        fieldName: "enableAutomaticCharge",
        widget: "checkbox",
        description: "Enable automatic charges according to cancellation policies",
        helpText:
          "When you activate this option, the reservation will be charged according to the cancellation penalty deadlines. This option only applies to supported payment methods (payment methods that allow deferred charges in the engine's back office).",
        defaultValue: false,
      },
      {
        fieldName: "penaltyDeposit",
        widget: "checkbox",
        description: "Execute first online payment - when incurring fees at the time of booking",
        helpText:
          "By activating this option and if expenses are incurred at the time of booking, the policy deposit will be charged",
        defaultValue: false,
      },
      {
        fieldName: "description",
        placeholder: "Description",
        displayName: "Description",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Associated engines",
      },
    ],
  },
};
